import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';

const ButtonGroup = ({
  disabled = false,
  primaryFunc = null,
  primaryText = null,
  secondaryFunc = null,
  secondaryText = 'Make Changes'
}) => {
  return (
    <Row className="py-3 align-items-center justify-content-between">
      <Col>
        <Flex justifyContent="center">
          {secondaryFunc && (
            <Button
              disabled={disabled} // Updated to use the disabled prop
              variant="outline-primary"
              color="primary"
              className="mx-2 my-1 btn-width"
              type="submit"
              onClick={secondaryFunc}
            >
              {secondaryText}
            </Button>
          )}
          {primaryFunc && (
            <Button
              disabled={disabled} // Updated to use the disabled prop
              color="primary"
              className="mx-2 my-1 btn-width"
              type="submit"
              onClick={primaryFunc}
            >
              {primaryText}
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );
};

ButtonGroup.propTypes = {
  disabled: PropTypes.bool,
  primaryFunc: PropTypes.any,
  primaryText: PropTypes.any,
  secondaryFunc: PropTypes.any,
  secondaryText: PropTypes.any
};

export default ButtonGroup;
